/* file description */
import SpComList from './sp-com-list';

export type { SpComListType } from './sp-com-list';
export default SpComList;

